if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.inquiry = document.querySelector('product-info inquiry-form');
      this.mainButton = this.inquiry
        ? this.inquiry.querySelector('[data-inquiry-submit]') || this.inquiry
        : document.querySelector('product-info product-form button[type="submit"]');
      if (!this.mainButton) return;

      // A COD form app (EasySell) adds its own order button after page load; use it once it appears.
      this.codButton = document.querySelector('product-info #es-popup-button');
      if (!this.codButton) {
        const productInfo = document.querySelector('product-info');
        if (productInfo) {
          this.codObserver = new MutationObserver(() => {
            const button = productInfo.querySelector('#es-popup-button');
            if (!button) return;
            this.codButton = button;
            this.codObserver.disconnect();
            if (this.observer) {
              this.observer.disconnect();
              this.observer.observe(button);
            }
          });
          this.codObserver.observe(productInfo, { childList: true, subtree: true });
        }
      }

      this.querySelector('[data-sticky-button]').addEventListener('click', () => {
        if (this.codButton) {
          this.codButton.click();
          return;
        }
        if (this.inquiry) {
          this.inquiry.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const first = this.inquiry.querySelector('input:not([type="hidden"]), select');
          if (first) setTimeout(() => first.focus({ preventScroll: true }), 400);
          return;
        }
        if (this.mainButton.disabled) {
          this.mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.mainButton.click();
      });

      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.passed = false;
      this.updateVisibility = () => {
        const mode = this.dataset.visibility;
        const always = mode === 'always' || (mode === 'mobile_always' && this.mobileQuery.matches);
        this.hidden = !(always || this.passed);
        document.body.classList.toggle('has-sticky-atc', !this.hidden);
      };
      this.mobileQuery.addEventListener('change', this.updateVisibility);

      this.observer = new IntersectionObserver(
        ([entry]) => {
          // the main button has scrolled above the viewport
          this.passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.updateVisibility();
        },
        { threshold: 0 }
      );
      this.updateVisibility();
      this.observer.observe(this.codButton || this.mainButton);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.updateVisibility);
      document.body.classList.remove('has-sticky-atc');
      if (this.codObserver) this.codObserver.disconnect();
      if (this.unsubscribe) this.unsubscribe();
    }

    onVariantChange(event) {
      const data = event && event.data;
      if (!data) return;
      const variantEl = this.querySelector('[data-sticky-variant]');
      if (variantEl && data.variant) variantEl.textContent = data.variant.title;

      const html = data.html;
      const priceEl = this.querySelector('[data-sticky-price]');
      if (html && priceEl) {
        const price = html.querySelector('[id^="price-"] .price');
        const source = price
          ? price.classList.contains('price--on-sale')
            ? price.querySelector('.price__sale .price-item--sale')
            : price.querySelector('.price__regular .price-item--regular')
          : null;
        if (source) priceEl.textContent = source.textContent.trim();
      }

      const button = this.querySelector('[data-sticky-button]');
      if (button && data.variant) button.disabled = !data.variant.available;
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
